import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=34822a2a&"
import script from "./Mark.vue?vue&type=script&lang=js&"
export * from "./Mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports